import { render, staticRenderFns } from "./CloudOrder.vue?vue&type=template&id=72299934&scoped=true&"
import script from "./CloudOrder.vue?vue&type=script&lang=js&"
export * from "./CloudOrder.vue?vue&type=script&lang=js&"
import style0 from "./CloudOrder.vue?vue&type=style&index=0&id=72299934&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72299934",
  null
  
)

export default component.exports